import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import noProductImage from '../../../images/no-product-image.png';

const ITEM_HEIGHT = 36;
const ITEM_PADDING_TOP = 6;

export const DataGridContainer = styled(Paper)({
  marginTop: '20px',
  marginLeft: '45px',
  width: 'calc(100% - 90px)',
  border: '0.9px solid #E3E5E8',
  boxSizing: 'border-box',
  boxShadow: '0px 0.9px 3.8px rgba(0, 0, 0, 0.2)',
  height: 'calc(100% - 310px)'
});

export const TenantFormControl = styled(FormControl)({
  width: '300px',
  height: '40px',
  marginTop: '25px',
  marginLeft: '25px',
  '&:hover': {
    '& .MuiInputLabel-root': {
      color: '#5F65F6'
    }
  },
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: '#5F65F6'
    }
  }
});

export const LocationFormControl = styled(FormControl)({
  width: '300px',
  height: '40px',
  marginTop: '25px',
  marginLeft: '16px',
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: '#5F65F6'
    }
  }
});

export const StyledInputLabel = styled(InputLabel)({
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: '400px'
});

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
    }
  }
};

export const StyledMenuItem = styled(MenuItem)({
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: '400px'
});

export const StyledTenantSelect = styled(Select)({
  // Borders css, if needed for future use
  // '& .MuiOutlinedInput-notchedOutline': {
  //   // borderColor: 'pink',
  // },
  '&.MuiOutlinedInput-root': {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: '400px'
  },
  maxHeight: 48 * 5,
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#5F65F6',
      borderWidth: '1px'
    }
  },
  '&:hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#5F65F6'
    }
  }
});

export const StyledLocationSelect = styled(Select)({
  // Borders css, if needed for future use
  // '& .MuiOutlinedInput-notchedOutline': {
  //   // borderColor: 'pink',
  // },
  '&.MuiOutlinedInput-root': {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: '400px'
  },

  maxHeight: 48 * 5,
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#5F65F6',
      borderWidth: '1px'
    }
  }
});

export const StyledTableContainer = styled(TableContainer)({
  marginTop: '10px',
  height: 'calc(100% + -75px)',
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    width: '5px',
    height: '5px'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,.1)'
  }
});

export const StyledHeaderRow = styled(TableRow)({
  height: '58px',
  whiteSpace: 'nowrap'
});

export const StyledUPCHeaderCell = styled(TableCell)({
  width: '15%',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '16px 24px 16px 50px',
  flex: 'none',
  whiteSpace: 'nowrap',
  order: 0,
  flexGrow: 0,
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: 600
});

export const StyledDisplayNameHeaderCell = styled(TableCell)({
  width: '17%',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '16px 24px 16px 16px',
  flex: 'none',
  order: 1,
  flexGrow: 0,
  margin: '0px 0px',
  overflow: 'hidden',
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: 600
});

export const StyledHeaderCell = styled(TableCell)({
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: 600
});

export const StyledTableRow = styled(TableRow)({
  height: '58px',
  '&.MuiTableRow-hover': {
    color: '#FFFFFF01',
    cursor: 'pointer'
  }
});

export const StyledTableCell = styled(TableCell)({
  padding: '0px 16px',
  fontFamily: 'Open Sans'
});

export const UPCCellContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'left',
  margin: 'auto',
  fontsize: '14px'
});

export const UPCImage = {
  borderRadius: '4px',
  marginRight: '16px',
  maxWidth: '28px',
  maxHeight: '28px',
  display: 'block',
  margin: 'auto'
};

export const TooltipImage = {
  maxWidth: '120px',
  maxHeight: '120px'
};

export const UPCTypography = styled(Typography)({
  fontFamily: 'Open Sans',
  letterSpacing: 0.15,
  fontSize: '14px'
});

export const DisplayNameTypography = styled(Typography)({
  width: '100%',
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  letterSpacing: 0.15,
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  fontSize: '14px',
  lineHeight: '22px',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical'
});

export const MoreResultsButton = styled(Button)({
  width: '165px',
  height: '58px',
  marginLeft: 'calc(50% + -82px)',
  fontFamily: 'Open Sans',
  padding: '6px 4px',
  fontWeight: 600,
  letterSpacing: 0.4,
  textTransform: 'capitalize',
  color: '#5F65F6',
  '&:hover': {
    backgroundColor: 'transparent'
  }
});

export const MoreResultsButtonIcon = styled(NavigateBeforeIcon)({
  color: '#5F65F6',
  transform: 'rotate(-90deg)'
});

export const fallBackImageUrl = noProductImage;

export const ProgressBar = styled(LinearProgress)({
  top: '137px',
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: 'rgb(95, 101, 246, 0.25)'
  },
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: 'rgb(95, 101, 246)'
  }
});

export const MoreResultsProgressBarContainer = styled(Box)({
  height: '58px',
  width: '100%',
  backgroundColor: 'transparent'
});

export const MoreResultsProgressBar = styled(LinearProgress)({
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: 'rgb(95, 101, 246, 0.25)'
  },
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: 'rgb(95, 101, 246)'
  }
});

export const ImageBox = styled(Box)({
  width: '28px',
  height: '28px',
  marginRight: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

export const TooltipImageBox = styled(Box)({
  width: '155px',
  height: '155px',
  marginRight: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'white',
  border: '1px solid rgba(0, 0, 0, 0.18)',
  borderRadius: '6px'
});

export const ButtonBox = styled(Box)({});

export const EditButton = styled(Button)({
  height: '30px',
  width: '46px',
  border: '1px solid rgba(63, 81, 181, 0.5)',
  borderColor: 'primary',
  borderRadius: '6px',
  textTransform: 'none',
  color: '#3F51B5',
  fontFamily: 'Open Sans',
  fontsize: '10px',
  fontWeight: 600,
  marginLeft: 'calc(100% - 90px)'
});

export const SearchFilterFormControl = styled(FormControl)({
  width: '300px',
  height: '40px',
  marginTop: '25px',
  marginLeft: 'calc(100% - 965px)',
  '&:hover': {
    '& .MuiInputLabel-root': {
      color: '#5F65F6'
    }
  },
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: '#5F65F6'
    }
  },
});

export const StyledSearchFilterSelect = styled(Select)({
  '&.MuiOutlinedInput-root': {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: '400px'
  },
  maxHeight: 48 * 5,
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#5F65F6',
      borderWidth: '1px'
    }
  },
  '&:hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#5F65F6'
    }
  }
});
